export default __webpack_public_path__ + "static/Bilo Medium-537246fbc88030c44ba49ffac369ba2e.otf";